/**
 * Script principal - main.js
 * Gère les jeux (1, 2, 3), les animations GSAP, la validation des interactions, etc.
 * Dernière mise à jour : 2025-07-17
 */

// Place ici les imports si utilisés via un bundler (sinon retirer)
import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
import interact from 'interactjs';
// import Swiper JS
import Swiper from 'swiper/bundle';
// import Swiper styles
import 'swiper/css';

// import tippy from 'tippy.js';
// import 'tippy.js/dist/tippy.css';
gsap.registerPlugin(ScrollTrigger);

//REVEAL ANIMATIONS
   function initRevealAnimations() {
        // Sélectionne tous les conteneurs avec la classe `.reveal`
        const revealContainers = document.querySelectorAll('.reveal');

        revealContainers.forEach(container => {
            // Sélectionne les enfants spécifiques (h1, h2, h3, h4, p, ul) dans chaque conteneur
            const textElements = container.querySelectorAll('h1, h2, h3, h4, p, ul, .reveal-item');
            const blockElements = container.querySelectorAll('.reveal-block');

            // Animation pour les éléments texte avec stagger
            if (textElements.length > 0) {
                gsap.set(textElements, { opacity: 0, y: 50 });
                gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: 'top 85%',
                        end: 'bottom 10%',
                        toggleActions: 'play none none none',
                    },
                }).to(textElements, {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    ease: 'power3.out',
                    stagger: 0.1, // Décalage entre chaque élément texte
                });
            }

            // Animation pour les éléments blocs (par exemple, images ou autres contenus)
            if (blockElements.length > 0) {
                gsap.set(blockElements, { opacity: 0, scale: 0.95 });
                blockElements.forEach(block => {
                    gsap.timeline({
                        scrollTrigger: {
                            trigger: block,
                            start: 'top 85%',
                            toggleActions: 'play none none none',
                        },
                    }).to(block, {
                        opacity: 1,
                        scale: 1,
                        duration: 0.6,
                        ease: 'power3.out',
                    });
                });
            }
        });
    }

// HOME LOGIN
document.addEventListener('DOMContentLoaded', () => {
    const connectForm = document.getElementById('cuir-connect');
    const connectBox = document.querySelector('.connect-box');
    const errorMessage = document.querySelector('.error-message');
    //const homeRevealElements = document.querySelectorAll('.reveal, .reveal-block');
    const body = document.body;
    const IFRAME_TOKEN = 't7PXrDOHZvMhRFugfwjUPsAOwYWCDjW4'; // Token attendu dans l'URL
    
    // Fonction pour vérifier le paramètre GET dans l'URL
    const getQueryParam = (key) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(key);
    };

        // Vérifie si l'utilisateur est authentifié via LocalStorage ou IframeToken
    const isAuthenticated = () => {
        const iframeToken = getQueryParam('iframeToken');
        if (iframeToken === IFRAME_TOKEN) {
            // Authentification via le token dans l'URL
            localStorage.setItem('authenticated', 'true');
            return true;
        }
        // Authentification via LocalStorage
        return localStorage.getItem('authenticated') === 'true';
    };

    //Fonction pour MAJ le body class
    const updateBodyClass = () => {
        if (isAuthenticated()) {
            body.classList.add('authenticated');
            body.classList.remove('not-authenticated');
        } else {
            body.classList.add('not-authenticated');
            body.classList.remove('authenticated');
        }
    };

    // Vérifie l'état d'authentification
    const handleAuthentication = () => {
        updateBodyClass();

        if (isAuthenticated()) {
            // Si l'utilisateur est authentifié, masquer la boîte de connexion
            if (connectBox) {
                connectBox.style.display = 'none';
            }
        } else {
            // Si l'utilisateur n'est pas authentifié
            const isHomePage = document.body.classList.contains('home');
            if (!isHomePage) {
                // Rediriger vers la page d'accueil
                window.location.href = '/';
            }
        }
    };
    if (connectForm) {
        connectForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            errorMessage.style.display = 'none';
            const input = connectForm.querySelector('input[type="password"]');
            const password = input.value.trim();

            if (!password) return;
            try {
                const response = await fetch('/ajax-login.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ password })
                });
                
                const result = await response.json();
                
                if (result.status === 'success') {
                    //Put Local storage
                    localStorage.setItem('authenticated', 'true');
                    // Étape 1 : Masquer la box avec une animation d'opacité
                    gsap.to(connectBox, {
                        opacity: 0,
                        duration: 0.4,
                        ease: 'power3.out',
                        onComplete: () => {
                            // Étape 2 : Mettre en display none après l'animation
                            connectBox.style.display = 'none';
                            updateBodyClass();
                        },
                    });
                } else {
                    errorMessage.style.display = 'block';
                }
            } catch (error) {
                console.error('Erreur lors de l\'authentification:', error);
            }
        });
    }
    // Appeler la fonction d'authentification au chargement
    handleAuthentication();

    // Ajouter un écouteur pour Barba.js pour gérer les transitions
    // barba.hooks.after(() => {
    //     handleAuthentication(); // Réévaluer l'authentification après chaque transition
    // });
});

//FONCTIONS AU RESIZE
    function handleResizeActions() {
        const popinElement = document.querySelector('.no-display');
        const transitionElement = document.querySelector('.page-transition');

        // Affiche ou masque la popin en fonction de la largeur de la fenêtre
        if (window.innerWidth < 1024) {
            popinElement?.classList.add('show-alert'); // Affiche la popin
        } else {
            popinElement?.classList.remove('show-alert'); // Cache la popin
        }

        // Repositionne .page-transition en haut
        if (transitionElement) {
            gsap.set(transitionElement, {
                y: window.innerHeight,
            });
        }
    }


// HOME JS
  function updateFloor() {
      const box = document.querySelector('.dressing_container').getBoundingClientRect();
      const floorStart = box.top + box.height * 0.9238971963; // 711 / 770.4
      document.documentElement.style.setProperty('--floor-top', floorStart + 'px');
  }
  

  function dressing(){
        const container = document.querySelector('.dressing_container');
        const items = container.querySelectorAll('a.dressing_item');
        const dim = container.querySelector('.dressing_dim');

        function reset(){
            dim.classList.remove('is-visible');
            items.forEach(i => i.classList.remove('is-active'));
        }

        items.forEach(item => {
            item.addEventListener('pointerenter', () => {
                console.log('enter');
                items.forEach(i => i.classList.remove('is-active'));
                item.classList.add('is-active');        // passe au-dessus du voile
                dim.classList.add('is-visible');        // affiche le voile
            });
            item.addEventListener('pointerleave', reset);
            
            // accessibilité clavier
            item.addEventListener('focusin', () => {
                items.forEach(i => i.classList.remove('is-active'));
                item.classList.add('is-active');
                dim.classList.add('is-visible');
            });
        });

        // sortir de la zone = tout remettre à zéro
        container.addEventListener('pointerleave', reset);
        container.addEventListener('focusout', (e) => {
            if (!container.contains(e.relatedTarget)) reset();
        });
  }

//TOOLTIPS
function homeTooltips() {
  // Jeu 2 — afficher .content_info_card au hover sur .info
  console.log('Tippy');

  tippy('a.dressing_item ', {
    content(reference) {
      const id = reference.getAttribute('data-template');
      const template = document.getElementById(id);
      return template.innerHTML;
    },
    allowHTML: true,
    placement: 'left',
    theme: 'kesacuir',
    maxWidth: '330px',
    interactive: false,
    followCursor: false,
    offset: [0, 18],
  });

}

//HOME POPIN INACTIVE
function initHelpPopin(options = {}) {
    const {
        delay = 20000,
        itemSelector = '.dressing_item',
        popinSelector = '.popin_dressing',
        oncePerSession = true,
        // nouvelles options
        sessionKey = `helpPopinShown:v2:${location.pathname}`, // scope par page
        ttl = 30 * 60 * 1000, // 30 min de validité
        debug = false,
    } = options;

    const log = (...a) => debug && console.log('[HelpPopin]', ...a);

    const popin = document.querySelector(popinSelector);
    if (!popin) { log('ABORT: popin introuvable'); return; }

    const closePopin = () => {
        popin.classList.remove('active');
        popin.setAttribute('aria-hidden', 'true');
        log('HIDE');
    };
    const bindCloseHandlers = () => {
        const closers = popin.querySelectorAll('.close-popin');
        closers.forEach(el => {
            el.addEventListener('click', (event) => {
                event.preventDefault();
                closePopin();
            });
        });
        log('close handlers bound', closers.length);
    };
    bindCloseHandlers();


    // RESET via param ?resetPopin=1
    const usp = new URLSearchParams(location.search);
    if (usp.has('resetPopin')) {
        sessionStorage.removeItem(sessionKey);
        log('reset via URL param');
    }

    // Lecture état stocké (namespacé + TTL)
    let shown = false;
    try {
        const raw = sessionStorage.getItem(sessionKey);
        if (raw) {
        const val = JSON.parse(raw);
        const expired = !val.ts || (Date.now() - val.ts > ttl);
        if (val.shown && !expired) shown = true;
        if (expired) sessionStorage.removeItem(sessionKey);
        log('stored state', { val, expired, shown });
        }
    } catch(e){ /* ignore */ }

    const showPopin = (reason = 'unknown') => {
        if (shown) { log('skip show (already)'); return; }
        shown = true;
        popin.classList.add('active');
        popin.setAttribute('aria-hidden', 'false');
        if (oncePerSession) {
        sessionStorage.setItem(sessionKey, JSON.stringify({ shown:true, ts:Date.now() }));
        }
        removeActivityListeners();
        removeItemListeners();
        clearTimeouts();
        log('SHOW', reason);
    };

    // Timers
    let inactivityTimer = null;
    let noHoverTimer = null;
    let noHoverArmed = true;

    const resetInactivity = () => {
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(() => showPopin('inactivity'), delay);
        log('arm inactivity', delay);
    };
    const armNoHover = () => {
        if (!noHoverArmed) { log('no-hover disarmed'); return; }
        clearTimeout(noHoverTimer);
        noHoverTimer = setTimeout(() => showPopin('no-hover'), delay);
        log('arm no-hover', delay);
    };
    const clearTimeouts = () => {
        clearTimeout(inactivityTimer);
        clearTimeout(noHoverTimer);
    };

    // Listeners
    const activityEvents = ['pointermove','mousedown','keydown','wheel','touchstart','scroll'];
    const onActivity = () => resetInactivity();
    function addActivityListeners(){
        activityEvents.forEach(ev => window.addEventListener(ev, onActivity, { passive:true }));
        resetInactivity();
        log('activity listeners added');
    }
    function removeActivityListeners(){
        activityEvents.forEach(ev => window.removeEventListener(ev, onActivity));
    }

    const items = Array.from(document.querySelectorAll(itemSelector));
    const onItemEnter = () => { noHoverArmed = false; clearTimeout(noHoverTimer); log('first hover'); };
    function addItemListeners(){
        items.forEach(el => {
        el.addEventListener('pointerenter', onItemEnter, { passive:true, once:true });
        el.addEventListener('focusin', onItemEnter, { once:true });
        });
        armNoHover();
        log('item listeners added', items.length);
    }
    function removeItemListeners(){
        items.forEach(el => {
        el.removeEventListener('pointerenter', onItemEnter);
        el.removeEventListener('focusin', onItemEnter);
        });
    }

    if (!shown) {
        addActivityListeners();
        addItemListeners();
    } else {
        log('already shown (within TTL) → no arm');
    }

}

//OBJET SWIPER


function initObjectSwiper() {
    function pauseMediaIn(slideEl) {
        // HTML5 <video>
        slideEl.querySelectorAll('video').forEach(v => {
            try { v.pause(); } catch(e){}
        });

        // YouTube iframe (exige enablejsapi=1 dans l'URL)
        slideEl.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]').forEach(iframe => {
            try {
                iframe.contentWindow.postMessage(JSON.stringify({
                event: 'command',
                func: 'pauseVideo',
                args: []
                }), '*');
            } catch(e){}
        });

        // Vimeo iframe
        slideEl.querySelectorAll('iframe[src*="vimeo.com"]').forEach(iframe => {
        try {
            iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
        } catch(e){}
        });
    }

    function pauseAllExceptActive(swiper) {
        swiper.slides.forEach((slide, idx) => {
        if (idx !== swiper.activeIndex) pauseMediaIn(slide);
        });
    }

    function pauseAllVideos(swiper) {
        swiper.slides.forEach((slide, idx) => {
        pauseMediaIn(slide);
        });
    }
    let endArmed = false;
    const prevBtn = document.querySelector('.mainSwiper .swiper-button-prev');
    const nextBtn = document.querySelector('.mainSwiper .swiper-button-next');
    const endBtn = document.querySelector('.mainSwiper .swiper-end-button');
    // Thumbs
    const thumbsSwiper = new Swiper('.thumbsSwiper', {
        spaceBetween: 12,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        navigation:false
    });

    // Principal (0.5s)
    const mainSwiper = new Swiper('.mainSwiper', {
        speed: 600,                 // ← 0.5s
        spaceBetween: 24,
        slidesPerView: 'auto',      // largeur gérée par CSS (80vw)
        navigation: {
            nextEl: '.mainSwiper .swiper-button-next',
            prevEl: '.mainSwiper .swiper-button-prev',
        },
        thumbs: { swiper: thumbsSwiper },
        keyboard: { enabled: true },

        // micro-parallax en drag
        on: {
            setTranslate(swiper) {
                swiper.slides.forEach(slide => {
                const p = slide.progress; // -1..1 autour de la slide active
                const img = slide.querySelector('.media img');
                if (img) {
                    // translate/scale diminue à l'approche de l'active
                    const t = -5 * (1 - Math.max(0, 1 - Math.abs(p)));
                    const s = 1.03 - 0.03 * Math.max(0, 1 - Math.abs(p));
                    img.style.transform = `translateX(${t}%) scale(${s})`;
                }
            });
        },
        transitionEnd(swiper){
            swiper.slides.forEach(slide=>{
            const img = slide.querySelector('.media img');
            if(img) img.style.transform = '';
            });
        }
        }
    });
    const updateNavigationState = (sw) => {
        console.log('Update navigation', { isBeginning: sw.isBeginning, isEnd: sw.isEnd });
        if (!prevBtn || !nextBtn) {
            return;
        }
        prevBtn.classList.toggle('is-hidden', sw.isBeginning);
        nextBtn.classList.toggle('is-hidden', sw.isEnd);
    };
    const lockEdges = (sw) => {
        // empêche tout léger translate quand on est au dernier slide
        sw.allowSlideNext = !sw.isEnd;
        console.log('Lock edges', { allowSlideNext: sw.allowSlideNext, isEnd: sw.isEnd });
    };

    const handleSlideChangeEnd = (sw) => {
        console.log('Slide changed', { isEnd: sw.isEnd });
        endArmed = sw.isEnd;
        console.log('Slide changed', { endArmed });
        pauseAllExceptActive(sw);
        updateNavigationState(sw);
        lockEdges(sw);
    };

    updateNavigationState(mainSwiper);

    // Pause dès qu’on quitte une slide, et double-sécurité à la fin de la transition
    mainSwiper.on('slideChangeTransitionStart', (sw) => {
        const prev = sw.slides[sw.previousIndex];
        if (prev) pauseMediaIn(prev);
    });
    mainSwiper.on('slideChangeTransitionEnd', handleSlideChangeEnd);
    
    mainSwiper.on('fromEdge', (sw) => {
        lockEdges(sw);
        updateNavigationState(sw);
        console.log('fromEdge', { endArmed  });
        
    });
    mainSwiper.on('reachBeginning', (sw) => {
        lockEdges(sw);
        updateNavigationState(sw);
        endArmed = false;
        console.log('reachBeginning', { endArmed  });
    });
    mainSwiper.on('reachEnd', (sw) => {
        lockEdges(sw);
        updateNavigationState(sw);
        endArmed = false;
        console.log('reachEnd', { endArmed  });
    });

    // Gestion de l’overlay à la fin
    const endOverlay = document.getElementById('endOverlay');
    const subHeader = document.querySelector('.sub-header');

    if (!endOverlay) {
        console.log('EndOverlay introuvable, fermeture désactivée');
        console.warn('[initObjectSwiper] Overlay introuvable, fermeture désactivée');
    } else {
        console.log('EndOverlay OK, fonction ON');
        // Même “désactivé” par Swiper, on garde le clic actif (CSS) et on intercepte
        if (endBtn) {
            endBtn.addEventListener('click', (e) => {
           // nextBtn.addEventListener('click', (e) => {
                console.log('click next', { endArmed, isEnd: mainSwiper.isEnd });
                //if (mainSwiper.isEnd && endArmed) {
                    e.preventDefault();
                    e.stopPropagation();
                    endOverlay.classList.add('visible');
                    subHeader.classList.add('overlay-visible'); 
                    endOverlay.setAttribute('aria-hidden', 'false');
                    pauseAllVideos(mainSwiper);
                    // Optionnel : exiger un nouveau clic après fermeture
                    // endArmed = false;
                //}
            });
        } else {
            console.warn('[initObjectSwiper] Bouton "next" introuvable, overlay non armé');
        }
        // Fermer en cliquant à l’extérieur
        endOverlay.addEventListener('click', (e) => {
            if (e.target === endOverlay) {
            endOverlay.classList.remove('visible');
            subHeader.classList.remove('overlay-visible');
            endOverlay.setAttribute('aria-hidden', 'true');
            }
        });
        // Échap
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
            endOverlay.classList.remove('visible');
            subHeader.classList.remove('overlay-visible');
            endOverlay.setAttribute('aria-hidden', 'true');
            }
        });
    }
    
}

function sizeObjectSlidesByViewport() {
    const HEADER_PLUS_SPACING = 150; // px
    const THUMBS_PLUS_SPACING = 200; // px
    const PANEL_W = 400;             // px
    const MAX_VW_RATIO = 0.95;       // 92vw
    const MIN_MEDIA_W = 320;         // sécurité petites fenêtres

    const vh = window.innerHeight;
    const vw = document.documentElement.clientWidth;

    // Hauteur dispo
    const slideH = Math.max(0, vh - (HEADER_PLUS_SPACING + THUMBS_PLUS_SPACING)); // = 100vh - 370px

    // Largeur basée sur 16/9 pour la zone média + panel
    const mediaW = Math.max(MIN_MEDIA_W, slideH * (16/9));
    const widthFromHeight = mediaW + PANEL_W;

    // Cap à 92vw
    const maxByVw = vw * MAX_VW_RATIO;
    const slideW = Math.min(widthFromHeight, maxByVw);

    const root = document.documentElement;
    root.style.setProperty('--panel-w', PANEL_W + 'px');
    root.style.setProperty('--slide-h', slideH + 'px');
    root.style.setProperty('--slide-w', slideW + 'px');

    if (window.mainSwiper?.update) {
        window.mainSwiper.update(); // si tu exposes ton instance globale
    }
}

function initTC() {
    initRevealAnimations();
    
   // initLevelSelector();
   //HOME
    if(document.querySelector(".dressing")){
        //Update Floor on load and resize
        window.addEventListener('load', updateFloor);
        window.addEventListener('resize', updateFloor);
        //JS dressing
        dressing();
        //popin aide
        initHelpPopin({
            delay: 10000,
            itemSelector: '.dressing_container a.dressing_item',
            popinSelector: '.popin_dressing',
            oncePerSession: true,
            debug: true,          // active les logs
            // sessionKey: 'helpPopinShown:v2:/', // (optionnel) forcer un scope custom
            ttl: 2*60*1000       // 30 min, ajuste à tes besoins
        });
        // Tooltips — protéger si tippy n’est pas chargé
        try {
            if (window.tippy) homeTooltips();
        } catch (e) {
            console.warn('homeTooltips ignoré (tippy non chargé) :', e);
        }
    }
    //PAGE OBJET
    if(document.querySelector(".mainSwiper")){
        initObjectSwiper();
        sizeObjectSlidesByViewport();
    }

}

document.addEventListener("DOMContentLoaded", initTC);

document.addEventListener('DOMContentLoaded', () => {
    handleResizeActions(); // Exécution au chargement
    window.addEventListener('resize', handleResizeActions); // Exécution lors du redimensionnement
});
window.addEventListener('load',  sizeObjectSlidesByViewport);
window.addEventListener('resize', sizeObjectSlidesByViewport);
